// see https://material-ui-next.com/customization/themes/
import { MuiThemeProvider as ThemeProvider } from '@material-ui/core/styles'

export default ThemeProvider
